export const initialNavigationUrl = window?.location?.href;
